var map = {
	"./404.svg": 4814,
	"./astronaut.svg": 179,
	"./coupon-1.svg": 2678,
	"./coupon-2.svg": 3925,
	"./coupon-3.svg": 8292,
	"./coupon-4.svg": 1355,
	"./coupon-img.svg": 6186,
	"./earth.svg": 8782,
	"./moon.svg": 6353,
	"./overlay_stars.svg": 5860,
	"./rocket.svg": 6346
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9653;
module.exports = webpackAsyncContext;